import { serviceInstance } from '../../../services'
import { TGetPetsTypes } from './types'

export const getPetsTypesList = async () => {
  const response = await serviceInstance.get<TGetPetsTypes>(
    '/pets/api/v1/admin/pet-type',
  )
  return response.data
}
